import React from "react";
import { PageLayout } from "../components/page-layout";
import Partner from "../components/Partner";
import { useRoles } from "../components/useRoles";

export const PartnerPage = () => {
  const { isAdmin, isPartner, isLoading } = useRoles();

  if (isLoading) {
    return <div>Loading...</div>;
  }

  if (!isPartner && !isAdmin) {
    return (
      <PageLayout>
        <div className="content-layout">
          <h1 id="page-title" className="content__title">
            Access Denied
          </h1>
          <div className="content__body">
            <p id="page-description">
              <span>You do not have permission to view this page.</span>
            </p>
          </div>
        </div>
      </PageLayout>
    );
  }

  return (
    <PageLayout>
      <div className="content-layout">
        <Partner />
      </div>
    </PageLayout>
  );
};
